import React from 'react';
import { InputSize } from '../input/types';
import { DropdownCompositeItem } from './DropdownCompositeItem';
import { DropdownCompositeOption } from './types';
import { CSSValueWithLength } from '../../styles';

export interface DropdownCompositeInternalOptionProps<OptionValue> {
  option: DropdownCompositeOption<OptionValue>;
  index: number;
  focusIndex?: number | null;
  selectedIndex?: number | null;
  size?: InputSize;
  width?: CSSValueWithLength;
  optionItemHeight?: number;
  keyExtractor?: (item: DropdownCompositeOption<OptionValue>, index: number) => string | number;
  onChange?: (value: OptionValue) => void;
  getItemProps: (props: Record<string, unknown>) => Record<string, unknown>;
  setRefs: (node: HTMLElement | null, index: number) => void;
}

export const DropdownCompositeInternalOption = <OptionValue,>({
  option,
  index,
  selectedIndex,
  focusIndex,
  width,
  optionItemHeight,
  onChange: handleChange,
  getItemProps,
  setRefs,
  keyExtractor,
}: DropdownCompositeInternalOptionProps<OptionValue>) => {
  const { disabled, value, label } = option;

  return (
    <DropdownCompositeItem
      key={keyExtractor?.(option, index)}
      tabIndex={focusIndex === index ? 0 : -1}
      aria-disabled={disabled}
      aria-selected={selectedIndex === index && focusIndex === index}
      data-selected={selectedIndex === index}
      disabled={disabled}
      selected={selectedIndex === index}
      focused={focusIndex === index}
      optionItemHeight={optionItemHeight}
      width={width}
      ref={(node) => setRefs(node, index)}
      {...getItemProps({
        onKeyDown(event: KeyboardEvent) {
          if (event.key === 'Enter' && !disabled) {
            event.preventDefault();
            handleChange?.(value);
          }
          if (event.key === '') {
            event.preventDefault();
          }
        },
        onClick() {
          !disabled && handleChange?.(value);
        },
      })}
    >
      {label}
    </DropdownCompositeItem>
  );
};
